import { render, staticRenderFns } from "./Before.vue?vue&type=template&id=60593ca6&scoped=true"
import script from "./Before.vue?vue&type=script&lang=js"
export * from "./Before.vue?vue&type=script&lang=js"
import style0 from "./Before.vue?vue&type=style&index=0&id=60593ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60593ca6",
  null
  
)

export default component.exports